.holiday__loader {
  height: 75vh;
}
